import React from "react";
import SEO from "../../components/SEO";
import { motion } from "framer-motion";
import BadgeTable from "../../components/account/BadgeTable";

function Badges() {
  return (
    <div className="p-2 lg:p-8">
      <SEO
        title="Badge Levels"
        description="At BOAF, we are committed to helping underserved communities."
        name="BOAF community"
        type="description"
      />
      <div className="flex items-center gap-x-3 mb-3">
        <p className="font-semibold">Badge Levels</p>
        <div className="w-[56px] h-[5px] bg-gray-300 rounded-full"></div>
      </div>

      <motion.div
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="shadow-xl rounded-3xl max-w-4xl bg-gradient-to-br from-[#E5ECFA]/100 via-[#F2F6FF]/50 to-[#FFFFFF]/100"
      >
        <BadgeTable />
      </motion.div>
    </div>
  );
}

export default Badges;
